import { BrowserRouter, Route, Routes } from 'react-router'
import FeedRoute from '@/routes/FeedRoute'
import NotFoundRoute from '@/routes/NotFoundRoute'
import PostBackRoute from '@/routes/PostBackRoute'
import PostFrontRoute from '@/routes/PostFrontRoute'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/feed" element={<FeedRoute />} />
        <Route path="/feed/post/:id" element={<PostFrontRoute />} />
        <Route path="/feed/post/:id/back" element={<PostBackRoute />} />
        <Route path="*" element={<NotFoundRoute />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
